import ApiConfig from "../config/Api.config";
import Request from "../interfaces/Request.interface";
import Response from "../interfaces/Response.interface";

const url = `${ApiConfig.URLBase}/actividad`

const listar = async (texto: string): Promise<Response> => {

    const request: Request = {
        url: `${url}/listar/${texto}`,
        metodo: "GET",
    }
    const response: Response = await ApiConfig.executeRequest(request);
    return response;

};


const ActividadService = {
    listar,
};

export default ActividadService;